import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const Legal: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-container">
      <div className="legal-content">
        <h1>Mentions Légales</h1>
        <p className="last-updated">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>

        <section>
          <h2>1. Éditeur du site</h2>
          <p>
            Le site web Bob Map est édité par :
          </p>
          <p>
            <strong>Hugo Bachellier - Entreprise individuelle</strong><br />
            SIREN : 924 766 702<br />
            Adresse : 9 Allée de la Fauvette, 37100 Tours, France<br />
            Email : <a href="mailto:bobmap.contact@gmail.com">bobmap.contact@gmail.com</a>
          </p>
        </section>

        <section>
          <h2>2. Directeur de la publication</h2>
          <p>
            <strong>Hugo Bachellier</strong><br />
            Email : <a href="mailto:bobmap.contact@gmail.com">bobmap.contact@gmail.com</a>
          </p>
        </section>

        <section>
          <h2>3. Hébergement</h2>
          <p>
            Le site Bob Map est hébergé par :
          </p>
          <p>
            <strong>Railway Corporation</strong><br />
            Adresse : 5670 Wilshire Blvd, Suite 1800, Los Angeles, CA 90036, États-Unis<br />
            Site web : <a href="https://railway.app" target="_blank" rel="noopener noreferrer">railway.app</a>
          </p>
        </section>

        <section>
          <h2>4. Données cartographiques</h2>
          <p>
            Les données cartographiques affichées sur Bob Map proviennent de{' '}
            <strong>OpenStreetMap</strong> et sont utilisées sous licence{' '}
            <a href="https://opendatacommons.org/licenses/odbl/" target="_blank" rel="noopener noreferrer">
              Open Database License (ODbL)
            </a>.
          </p>
          <p>
            © OpenStreetMap contributors<br />
            Site web : <a href="https://www.openstreetmap.org" target="_blank" rel="noopener noreferrer">
              www.openstreetmap.org
            </a>
          </p>
        </section>

        <section>
          <h2>5. Propriété intellectuelle</h2>
          <p>
            L'ensemble du contenu de ce site (structure, design, code source, logos, textes, images)
            est la propriété exclusive de Hugo Bachellier, sauf mention contraire.
          </p>
          <p>
            Toute reproduction, représentation, modification, publication ou exploitation non autorisée
            de tout ou partie du site est strictement interdite et constitue une contrefaçon sanctionnée
            par les articles L.335-2 et suivants du Code de la Propriété Intellectuelle.
          </p>
        </section>

        <section>
          <h2>6. Données personnelles</h2>
          <p>
            Le traitement des données personnelles collectées sur Bob Map est conforme au Règlement
            Général sur la Protection des Données (RGPD - Règlement UE 2016/679).
          </p>
          <p>
            Pour plus d'informations, consultez notre{' '}
            <Link to="/privacy-policy">Politique de Confidentialité</Link>.
          </p>
          <p>
            <strong>Responsable du traitement :</strong> Hugo Bachellier<br />
            <strong>Contact DPO :</strong> <a href="mailto:bobmap.contact@gmail.com">bobmap.contact@gmail.com</a>
          </p>
        </section>

        <section>
          <h2>7. Cookies et technologies similaires</h2>
          <p>
            Bob Map utilise <strong>uniquement le localStorage</strong> pour stocker votre token d'authentification.
          </p>
          <p>
            Aucun cookie de suivi, de mesure d'audience ou de publicité n'est utilisé.
          </p>
          <p>
            Le localStorage n'est pas soumis au consentement des cookies selon la directive ePrivacy.
          </p>
        </section>

        <section>
          <h2>8. Limitation de responsabilité</h2>

          <h3>8.1 Contenu du site</h3>
          <p>
            Nous nous efforçons de fournir des informations exactes et à jour, mais ne pouvons garantir
            l'exactitude, la complétude ou l'actualité des informations présentes sur Bob Map.
          </p>

          <h3>8.2 Disponibilité du service</h3>
          <p>
            L'accès au site peut être interrompu temporairement pour maintenance, mise à jour ou
            pour tout autre motif technique.
          </p>
          <p>
            Nous ne pouvons être tenus responsables de l'indisponibilité temporaire ou totale du service.
          </p>

          <h3>8.3 Liens externes</h3>
          <p>
            Bob Map peut contenir des liens vers des sites externes. Nous ne sommes pas responsables
            du contenu de ces sites ni de leur politique de confidentialité.
          </p>
        </section>

        <section>
          <h2>9. Accessibilité</h2>
          <p>
            Nous nous efforçons de rendre Bob Map accessible au plus grand nombre, conformément aux
            standards WCAG (Web Content Accessibility Guidelines).
          </p>
          <p>
            Si vous rencontrez des difficultés d'accessibilité, contactez-nous à{' '}
            <a href="mailto:bobmap.contact@gmail.com">bobmap.contact@gmail.com</a>.
          </p>
        </section>

        <section>
          <h2>10. Droit applicable</h2>
          <p>
            Les présentes mentions légales sont régies par le droit français.
          </p>
          <p>
            En cas de litige, et après tentative de résolution amiable, les tribunaux français
            seront seuls compétents.
          </p>
        </section>

        <section>
          <h2>11. Contact</h2>
          <p>
            Pour toute question concernant les mentions légales, contactez-nous :
          </p>
          <p>
            Email : <a href="mailto:bobmap.contact@gmail.com">bobmap.contact@gmail.com</a><br />
            Adresse postale : 9 Allée de la Fauvette, 37100 Tours, France
          </p>
        </section>

        <div className="legal-footer">
          <Link to="/privacy-policy" className="legal-link">Politique de Confidentialité</Link>
          <Link to="/terms" className="legal-link">Conditions Générales d'Utilisation</Link>
          <Link to="/my-data" className="legal-link">Gérer mes données</Link>
        </div>
      </div>
    </div>
  );
};

export default Legal;
